/**
 * Quem é administrador.
 *
 * O papel passou a vir do VÍNCULO do usuário com o espaço (`usuario_tenant`),
 * e não mais de um campo global: a mesma pessoa pode ser admin num diretório e
 * atendente em outro.
 *
 * Três caminhos são aceitos:
 *
 *   papel === 'admin'   → admin deste espaço
 *   plataforma_papel    → admin/suporte da plataforma, entra em qualquer um
 *   super === 1         → LEGADO, temporário
 *
 * O `super` está aqui só para não trancar quem já estava logado quando o
 * deploy sobe: o token antigo não carrega `papel`. Sai quando todas as sessões
 * tiverem sido renovadas. Espelha `backend/src/app/middlewares/superOnly.js`.
 */

export function ehAdmin(user) {
  if (!user) return false;
  return user.papel === 'admin'
    || user.plataforma_papel === 'admin'
    || user.plataforma_papel === 'suporte'
    || user.super === 1;
}

/** Usuário com acesso além do próprio espaço (suporte/admin da plataforma). */
export function ehPlataforma(user) {
  return user?.plataforma_papel === 'admin' || user?.plataforma_papel === 'suporte';
}

export default { ehAdmin, ehPlataforma };
